import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster } from '@/Components/ui/sonner';
import Home from './Components/Home';
import Signup from './Components/Signup';
import Login from './Components/Login'
import LoginProfile from './Profile/LoginProfile';
import JobsPage from './JobPage/JobsPage';
import Explore from './Components/Explore';
import Companyoverview from './Components/CompanyOverview';
import CompanySpecificJobs from './Components/CompanySpecificJobs';
import Tempoverview from './Components/Tempoverview';
import Layoff from './Components/Layoff';
import Trends from './Components/Trends';
import OpenTredns from './Components/OpenTrend';
import BigTechHirings from './Components/BigTechHiring';
import TopTechLocation from './Components/TopTechLocations';
import TechStatPage from './Components/TechStatPage';
import RemoteStat from './Components/RemoteStats';
import { AuthProvider } from './Context/AuthContext';
import Dashboard from './Components/Dashboard';
import { AdminRoute } from './Components/AdminRoute';
import NotFound from './Components/NotFound';
import Hiringpage from './HireWithUs/Components/Hiringpage';
import SignUp from './HireWithUs/Components/SignUp';
import Jobpostpricing from './HireWithUs/Components/Jobpostpricing';
import Postjob from './HireWithUs/Components/Postjob';
import { PostJobLanding } from './HireWithUs/Pages/PostJob/PostJobLanding';
import Companysetup from './HireWithUs/Components/Companysetup';
import CompanySettings from './HireWithUs/Pages/Settings/CompanySettings';
import SavedInterviewersPage from './HireWithUs/Pages/Settings/SavedInterviewersPage';
import RecruitersPage from './HireWithUs/Pages/Settings/RecruitersPage';
import TemplatesHubPage from './HireWithUs/Pages/Settings/TemplatesHubPage';
import AptitudeBuilderPage from './HireWithUs/Pages/Settings/AptitudeBuilderPage';
import PnbBuilderPage from './HireWithUs/Pages/Settings/PnbBuilderPage';
import { ProgressProvider } from './HireWithUs/Context/CompanyContext';
import Findcandidate from './HireWithUs/Components/Findcandidate';
import Savedcandidates from './HireWithUs/Components/Savedcandidates';
import Myjobs from './HireWithUs/Components/Myjobs';
import OverView from './HireWithUs/Components/Overview';
import Employerpage from './HireWithUs/Components/Employerpage';
import Employerprofile from './HireWithUs/Components/EmployerProfile';
import BillingPage from './HireWithUs/Components/BillingPage';
import ApplicationsPage from './HireWithUs/Components/ApplicationsPage';
import HiredProfilesPage from './HireWithUs/Components/HiredProfilesPage';
import BackfillPage from './HireWithUs/Pages/Backfill/BackfillPage';
import HiringLifecycle from './HireWithUs/Pages/HiringLifecycle/HiringLifecycle';
import CandidateOfferResponse from './HireWithUs/Pages/OfferResponse/CandidateOfferResponse';
import { InterviewDashboard } from './HireWithUs/Pages/Interview/InterviewDashboard';
import MyInterviews from './HireWithUs/Pages/MyInterviews/MyInterviews';
import Loginpage from './HireWithUs/Components/Login';
import ScrollToTop from './HireWithUs/Context/ScrollTop';
import SelectTopic from './HireWithUs/Components/SelectTopic';
import { CompanyProvider } from './HireWithUs/Context/cidContext';
import Reports from './HireWithUs/Pages/Interview/IndividualResult/Reports';
// Phase 8 — Layer 10 Evidence Dashboard. Per-signal breakdown for one
// candidate's coding test (MOSS / AI judge / online / snapshots / identity).
import CheatingEvidence from './HireWithUs/Pages/CheatingEvidence/CheatingEvidence';
import { HireWithUsProtectedRoute } from './HireWithUs/Components/HireWithUsProtectedRoute';
import { CompanyAccessProvider } from './HireWithUs/Context/CompanyAccessContext';
import AcceptInvite from './HireWithUs/Pages/Login/AcceptInvite';
import TeamPage from './HireWithUs/Pages/Settings/TeamPage';
import ActivityPage from './HireWithUs/Pages/Settings/ActivityPage';
import { Connect } from './HireWithUs/Pages/Contact/Connect';
import AboutUs from './HireWithUs/Pages/AboutUs/AboutUs';
import StaffingServices from './HireWithUs/Pages/Services/StaffingServices';
import FractionalHiring from './HireWithUs/Pages/Services/FractionalHiring';
import AISourcingScreening from './HireWithUs/Pages/Services/AISourcingScreening';
import AICallScreening from './HireWithUs/Pages/Services/AICallScreening';
import ContactPublic from './HireWithUs/Pages/AboutUs/ContactPublic';
import PrivacyPolicy from './HireWithUs/Pages/Legal/PrivacyPolicy';
import VirtualHiring from './HireWithUs/Pages/VirtualHiring/VirtualHiring';
import CodingAssessment from './HireWithUs/Pages/CodingAssessment/CodingAssessment';
import ScreeningAssessment from './HireWithUs/Pages/ScreeningAssessment/ScreeningAssessment';
import FunctionalAssessment from './HireWithUs/Pages/FunctionalAssessment/FunctionalAssessment';
import TechnologyHiring from './HireWithUs/Pages/Industries/TechnologyHiring';
import BfsiHiring from './HireWithUs/Pages/Industries/BfsiHiring';
import SolutionsHub from './HireWithUs/Pages/Solutions/SolutionsHub';
import StartupHiring from './HireWithUs/Pages/Solutions/StartupHiring';
import EnterpriseHiring from './HireWithUs/Pages/Solutions/EnterpriseHiring';
import HighVolumeHiring from './HireWithUs/Pages/Solutions/HighVolumeHiring';
import GccHiring from './HireWithUs/Pages/Solutions/GccHiring';
import AiRecruitment from './HireWithUs/Pages/Solutions/AiRecruitment';
import RpoHiring from './HireWithUs/Pages/Solutions/RpoHiring';
import AiScreening from './HireWithUs/Pages/Solutions/AiScreening';
import VoiceWhatsAppRecruiting from './HireWithUs/Pages/Solutions/VoiceWhatsAppRecruiting';
import Platform from './HireWithUs/Pages/Platform/Platform';
import ForgotPassword from './HireWithUs/Pages/Login/ForgotPassword';
import ResetPassword from './HireWithUs/Pages/Login/ResetPassword';
import BackendRedirectHandler from './HireWithUs/Pages/Login/BackendRedirectHandler';
import BlogHome from './Blog/BlogHome';
import BlogPost from './Blog/BlogPost';
import AIHiringGuide from './HireWithUs/Pages/Resources/AIHiringGuide';
import CaseStudies from './Blog/CaseStudies';
import ManestCaseStudy from './Blog/ManestCaseStudy';
import GrandGamingCaseStudy from './Blog/GrandGamingCaseStudy';
import KinzyClubCaseStudy from './Blog/KinzyClubCaseStudy';
import CaseStudyLinkedIn, { linkedInCarousels } from './Blog/LinkedInCarousel';
import PostJobAiText from './HireWithUs/Components/PostJobAiText';
import PostJobAiVoice from './HireWithUs/Components/PostJobAiVoice';
import UploadJobDescription from './HireWithUs/Pages/PostJob/UploadJD';
import Event from './HireWithUs/Pages/AboutUs/Event';
import CompanyAdmin from './CompanyAdmin/CompanyAdmin';
import { AuthProvider as CompanyAdminAuthProvider } from './CompanyAdmin/Context/AuthContext';
// import RecruiterLogin from './HireWithUs/Pages/Login/RecruiterLogin';
import RecruiterLoginPage from './HireWithUs/Pages/Login/RecruiterLoginPage';
import RecruiterCompleteProfile from './HireWithUs/Pages/Recruiter/RecruiterCompleteProfile';
import RecruiterProtectedRoute from './HireWithUs/Pages/Recruiter/RecruiterProtectedRoute';
import RecruiterDashboard from './HireWithUs/Pages/Recruiter/RecruiterDashboard';
import { RecruiterAuthProvider } from './CompanyAdmin/Context/RecruiterAuthContext';
import { RecruiterMyJobs } from './HireWithUs/Pages/Recruiter/RecruiterMyJobs';
import { JobDetails } from './HireWithUs/Pages/Recruiter/RecruiterJobDetails';
import { ApplicationsPage as RecruiterApplicationsPage } from './HireWithUs/Pages/Recruiter/RecruiterApplicationsPage';
import PublicJobsPage from './HireWithUs/Pages/PublicJobs/PublicJobsPage';
import WhatsAppInbox from './HireWithUs/Pages/Messages/WhatsAppInbox';
import CompanyJobsPage from './HireWithUs/Pages/PublicJobs/CompanyJobsPage';
import PublicEntry from './HireWithUs/Pages/PublicJobs/PublicEntry';
import LinkedInCallback from './HireWithUs/Pages/Broadcast/LinkedInCallback';
import { getSubdomainFromLocation } from './HireWithUs/Pages/PublicJobs/useSubdomain';
import LiveInterviewJoinRoomPage from './LiveInterview/pages/JoinRoomPage';
import InterviewerFeedbackPage from './LiveInterview/pages/InterviewerFeedbackPage';
import InterviewBookingManagePage from './LiveInterview/pages/InterviewBookingManagePage';
import InterviewBookingReschedulePage from './LiveInterview/pages/InterviewBookingReschedulePage';
import InterviewBookingHashRedirect from './LiveInterview/components/InterviewBookingHashRedirect';
import LiveInterviewRoomPage from './LiveInterview/pages/RoomPage';
import DemoPage from './HireWithUs/Pages/Demo/DemoPage';
import ZiaCallConsole from './HireWithUs/Pages/Demo/ZiaCallConsole';
import BookDemo from './HireWithUs/Pages/Demo/BookDemo';

/**
 * Component for the apex `/` route. Branches on whether we're on a
 * company subdomain — if so, render that company's careers page; if not,
 * render the regular Hiringpage marketing landing.
 *
 * Defined inline at the top of App.js so it can use the existing
 * Hiringpage import without restructuring imports.
 */
function RootRoute() {
  if (getSubdomainFromLocation()) {
    return <PublicEntry mode="root" />;
  }
  return <Hiringpage />;
}

const App = () => {

  return (
    <CompanyProvider>
      <RecruiterAuthProvider>
        <Router>
        <ScrollToTop />
        <InterviewBookingHashRedirect />
          <AuthProvider>
            <CompanyAccessProvider>
            <ProgressProvider>
              <Toaster />
              <Routes>

                <Route path="/recruiter/login" element={<RecruiterLoginPage />} />

                <Route path="/recruiter/complete-profile" element={
                  <RecruiterProtectedRoute>
                    <RecruiterCompleteProfile />
                  </RecruiterProtectedRoute>
                } />

                <Route path="/recruiter/dashboard" element={
                  <RecruiterProtectedRoute>
                    <RecruiterDashboard />
                  </RecruiterProtectedRoute>
                } />

                <Route path="/recruiter/my-jobs" element={
                  <RecruiterProtectedRoute>
                    <RecruiterMyJobs />
                  </RecruiterProtectedRoute>
                } />

                <Route path="/recruiter/job-details" element={
                  <RecruiterProtectedRoute>
                    <JobDetails />
                  </RecruiterProtectedRoute>
                } />

                <Route path="/recruiter/applications" element={
                  <RecruiterProtectedRoute>
                    <RecruiterApplicationsPage />
                  </RecruiterProtectedRoute>
                } />

                <Route path="/interview-room/join/:inviteToken" element={<LiveInterviewJoinRoomPage />} />
                <Route path="/interview-room/:roomId" element={<LiveInterviewRoomPage />} />
                <Route path="/interview-feedback" element={<InterviewerFeedbackPage />} />
                <Route path="/interview-booking" element={<InterviewBookingManagePage />} />
                <Route path="/interview-booking/:token" element={<InterviewBookingManagePage />} />
                <Route path="/interview-booking/:action/:token" element={<InterviewBookingManagePage />} />
                <Route path="/interview-booking/manage" element={<InterviewBookingManagePage />} />
                <Route path="/interview-booking/manage/:token" element={<InterviewBookingManagePage />} />
                <Route path="/interview-booking/reschedule" element={<InterviewBookingReschedulePage />} />
                <Route path="/interview-booking/reschedule/:token" element={<InterviewBookingReschedulePage />} />

                {/* ============================================
                    Public job board (no auth required)

                    Routing is subdomain-aware:
                      • On `acme.yourapp.com/anything` → PublicEntry detects
                        the subdomain from window.location.hostname and
                        renders CompanyJobsPage for "acme" — overriding any
                        path-based routing below.
                      • On `yourapp.com` (apex)        → falls through to
                        the explicit routes below.

                    Apex-domain routes:
                      /jobs            → master listing
                      /jobs/:jobId     → one job's own page (shared links,
                                         jobs feed, search engines) — on
                                         tenant subdomains too
                      /c/:slug         → one company's careers page (path)
                      /c/:slug/:jobId  → company page + open one job (path)
                    ============================================ */}
                <Route path="/jobs" element={<PublicEntry mode="root" />} />
                <Route path="/jobs/:jobId" element={<PublicEntry mode="root" />} />
                <Route path="/c/:slug" element={<PublicEntry mode="company" />} />
                <Route path="/c/:slug/:jobId" element={<PublicEntry mode="company" />} />

                {/* LinkedIn returns here after an employer connects their
                    account for job posts (Broadcast panel). Not behind the
                    route guard: it usually runs in a popup, and the API call
                    it makes is what enforces who is signed in. */}
                <Route path="/hirewithus/linkedin/callback" element={<LinkedInCallback />} />

                <Route path="/login" element={
                  
                    <Login />
                }
                  />

                <Route path="/signup" element={<Signup />} />

                {/* Root path — subdomain-aware. On a tenant subdomain
                    (e.g. creowis.searchjob.ai) the visitor lands on that
                    company's careers page; on the apex domain they see
                    the marketing/hiring landing page as before. */}
                <Route path="/" element={<RootRoute />} />
                
                {/* Original Home route commented out temporarily */}
                {/* <Route path="/" element={
                  
                    <Home />
                
                } /> */}

                <Route path="/profile" element={
                
                    <LoginProfile />
                  
                } />

              <Route path="/reports" element={
                  <Reports/>
              } />

              {/* Phase 8 — Layer 10 Evidence Dashboard.
                  Accepts test_id via path param OR ?test_id=... query so
                  recruiter listing-page chips can deep-link with the simplest
                  href possible. Reads from /api/cheating/dashboard/<test_id>
                  and renders per-signal panels for code plagiarism, identity,
                  snapshots, room scan, and chronological event timeline.

                  No protected-route wrapper: this dashboard needs to be
                  reachable by BOTH recruiter sessions (HireWithUs auth)
                  AND super-admin sessions (CompanyAdmin auth). The legacy
                  HireWithUsProtectedRoute only recognises the recruiter
                  session and bounces super-admins to /hirewithus/login —
                  which breaks the entry point from All.jsx in CompanyAdmin.
                  The backend endpoint does the access check itself. */}
              <Route path="/hirewithus/cheating-evidence/:testId" element={
                <CheatingEvidence />
              } />
              <Route path="/hirewithus/cheating-evidence" element={
                <CheatingEvidence />
              } />

                <Route path="/jobpage" element={
                  
                    <JobsPage />
                  
                } />

                <Route path="/explore" element={
                  
                    <Explore />
                  
                } />

                <Route path="/companyoverview/:compnayId" element={
                  
                    <Companyoverview />
                  
                } />

                <Route path="/companySpecificJobs/:compnayId" element={
                  
                    <CompanySpecificJobs />
                  
                } />

                <Route path="/tempoverview/:compnayId" element={
                  
                    <Tempoverview />
                  
                } />

                <Route path="/layoff" element={
                  
                    <Layoff />
                  
                } />

                <Route path="/trends" element={
                
                    <Trends />
                
                } />

                <Route path="/OpenTechJobs" element={
                  
                    <OpenTredns />
                  
                } />

                <Route path="/BigTechHiring" element={
                  
                    <BigTechHirings />
                
                } />

                <Route path="/TopTechLocation" element={
                  
                    <TopTechLocation />
                
                } />

                <Route path="/TechIndustryStats" element={
                  
                    <TechStatPage />
                  
                } />

                <Route path="/RemoteIndex" element={
                  
                    <RemoteStat />
                
                } />

                <Route path="/hirewithus/event" element={<Event />} />

                <Route path="/dashboard" element={
                  <AdminRoute>
                    <Dashboard />
                  </AdminRoute>
                } />

                <Route path="/unauthorized" element={<NotFound />} /> 
                <Route path="/hirewithus" element={<Hiringpage />} />
                <Route path="/hirewithus/about" element={<AboutUs />} />
                <Route path="/hirewithus/staffing" element={<StaffingServices />} />
                <Route path="/hirewithus/fractional" element={<FractionalHiring />} />
                <Route path="/hirewithus/ai-sourcing-screening" element={<AISourcingScreening />} />
                <Route path="/hirewithus/ai-call-screening" element={<AICallScreening />} />
                <Route path="/hirewithus/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/hirewithus/coding-assessment" element={<CodingAssessment />} />
                <Route path="/hirewithus/screening-assessment" element={<ScreeningAssessment />} />
                <Route path="/hirewithus/functional-assessment" element={<FunctionalAssessment />} />
                <Route path="/hirewithus/virtualhiring" element={<VirtualHiring />} />
                <Route path="/hirewithus/contact" element={<ContactPublic />} />
                <Route path="/hirewithus/signup" element={<SignUp />} />
                <Route path="/hirewithus/demo" element={<DemoPage />} />
                <Route path="/hirewithus/zia-console" element={<ZiaCallConsole />} />
                <Route path="/hirewithus/book-demo" element={<BookDemo />} />
                <Route path="/hirewithus/login" element={<Loginpage />} />
                <Route path="/hirewithus/forgot-password" element={<ForgotPassword />} />
                <Route path="/hirewithus/reset-password/:token" element={<ResetPassword />} />
                <Route path="/hirewithus/accept-invite/:token" element={<AcceptInvite />} />
                <Route path="/reset-password-employer/:token" element={<BackendRedirectHandler />} />
                <Route path="/reset-password-employer" element={<BackendRedirectHandler />} />
                <Route path="/hirewithus/jobpostpricing" element={<Jobpostpricing />} />
                <Route path="/hirewithus/postjob" element={
                  <HireWithUsProtectedRoute permission="jobs.create">
                    <PostJobLanding />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/postjob/create" element={
                  <HireWithUsProtectedRoute permission="jobs.create">
                    <Postjob />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/postjob/ai-text" element={
                  <HireWithUsProtectedRoute permission="jobs.create">
                    <PostJobAiText />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/postjob/ai-voice" element={
                  <HireWithUsProtectedRoute permission="jobs.create">
                    <PostJobAiVoice />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/postjob/upload-jd" element={
                  <HireWithUsProtectedRoute permission="jobs.create">
                    <UploadJobDescription />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/company/companysetup" element={
                  <HireWithUsProtectedRoute permission="settings.company">
                    <Companysetup />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/company/foundingsetup" element={
                  <HireWithUsProtectedRoute permission="settings.company">
                    <Companysetup />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/company/socials" element={
                  <HireWithUsProtectedRoute permission="settings.company">
                    <Companysetup />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/company/contact" element={
                  <HireWithUsProtectedRoute permission="settings.company">
                    <Companysetup />
                  </HireWithUsProtectedRoute>
                } />
                {/* Company Settings Routes - Same functionality as company setup but with Header + Sidebar */}
                <Route path="/hirewithus/settings/companysetup" element={
                  <HireWithUsProtectedRoute permission="settings.company">
                    <CompanySettings />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/settings/foundingsetup" element={
                  <HireWithUsProtectedRoute permission="settings.company">
                    <CompanySettings />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/settings/socials" element={
                  <HireWithUsProtectedRoute permission="settings.company">
                    <CompanySettings />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/settings/contact" element={
                  <HireWithUsProtectedRoute permission="settings.company">
                    <CompanySettings />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/settings/interviewers" element={
                  <HireWithUsProtectedRoute permission="settings.interviewers">
                    <SavedInterviewersPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/settings/templates" element={
                  <HireWithUsProtectedRoute permission="tests.templates">
                    <TemplatesHubPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/settings/aptitude-builder" element={
                  <HireWithUsProtectedRoute permission="tests.templates">
                    <AptitudeBuilderPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/settings/pnb-builder" element={
                  <HireWithUsProtectedRoute permission="tests.templates">
                    <PnbBuilderPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/settings/team" element={
                  <HireWithUsProtectedRoute permission="team.manage">
                    <TeamPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/settings/activity" element={
                  <HireWithUsProtectedRoute permission="audit.view">
                    <ActivityPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/settings/recruiters" element={
                  <HireWithUsProtectedRoute permission="settings.vendors">
                    <RecruitersPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/findcandidate" element={
                  <HireWithUsProtectedRoute permission="candidates.view">
                    <Findcandidate />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/sc" element={
                  <HireWithUsProtectedRoute permission="candidates.view">
                    <Savedcandidates />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/my-jobs" element={
                  <HireWithUsProtectedRoute permission="jobs.view">
                    <Myjobs />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/my-jobs/:jobId" element={
                  <HireWithUsProtectedRoute permission="jobs.view">
                    <Myjobs />
                  </HireWithUsProtectedRoute>
                } />

    <Route path="/hirewithus/Connect" element={
                  <HireWithUsProtectedRoute forInterviewers>
                    <Connect />
                  </HireWithUsProtectedRoute>
                } />

                <Route path="/hirewithus/overview" element={
                  <HireWithUsProtectedRoute permission="jobs.view">
                    <OverView />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/employerpage" element={
                  <HireWithUsProtectedRoute permission="settings.company">
                    <Employerpage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/employerpage/employerpf" element={
                  <HireWithUsProtectedRoute permission="settings.company">
                    <Employerprofile />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/billing" element={
                  <HireWithUsProtectedRoute permission="billing.view">
                    <BillingPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/applications" element={
                  <HireWithUsProtectedRoute permission="candidates.view">
                    <ApplicationsPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/messages" element={
                  <HireWithUsProtectedRoute permission="messages.view">
                    <WhatsAppInbox />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/interview" element={
                  <HireWithUsProtectedRoute permission="interviews.view">
                    <InterviewDashboard />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/my-interviews" element={
                  <HireWithUsProtectedRoute permission="interviews.view" forInterviewers>
                    <MyInterviews />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/interview/selecttopic" element={
                  <HireWithUsProtectedRoute permission="tests.schedule">
                    <SelectTopic />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/hired-profiles" element={
                  <HireWithUsProtectedRoute permission="onboarding.view">
                    <HiredProfilesPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/backfill" element={
                  <HireWithUsProtectedRoute permission="sourcing.talent_match">
                    <BackfillPage />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/hiring-lifecycle" element={
                  <HireWithUsProtectedRoute permission={['offers.view', 'onboarding.view']}>
                    <HiringLifecycle />
                  </HireWithUsProtectedRoute>
                } />
                <Route path="/hirewithus/offer/:token" element={<CandidateOfferResponse />} />
                <Route path="/industries/technology" element={<TechnologyHiring />} />
                <Route path="/industries/bfsi" element={<BfsiHiring />} />
                <Route path="/solutions" element={<SolutionsHub />} />
                <Route path="/solutions/startup-hiring" element={<StartupHiring />} />
                <Route path="/solutions/enterprise" element={<EnterpriseHiring />} />
                <Route path="/solutions/high-volume-hiring" element={<HighVolumeHiring />} />
                <Route path="/solutions/gcc-hiring" element={<GccHiring />} />
                <Route path="/solutions/ai-recruitment" element={<AiRecruitment />} />
                <Route path="/solutions/rpo" element={<RpoHiring />} />
                <Route path="/solutions/ai-screening" element={<AiScreening />} />
                <Route path="/solutions/voice-whatsapp" element={<VoiceWhatsAppRecruiting />} />
                <Route path="/platform" element={<Platform />} />
                <Route path="/resources/ai-hiring-guide" element={<AIHiringGuide />} />
                
                {/* Blog Routes */}
                <Route path="/blog" element={<BlogHome />} />
                <Route path="/blog/:id" element={<BlogPost />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/case-studies/manest-ai" element={<ManestCaseStudy />} />
                <Route path="/case-studies/grand-gaming" element={<GrandGamingCaseStudy />} />
                <Route path="/case-studies/kinzy-club" element={<KinzyClubCaseStudy />} />
                <Route path="/case-studies/manest-ai/linkedin" element={<CaseStudyLinkedIn study={linkedInCarousels.manest} />} />
                <Route path="/case-studies/grand-gaming/linkedin" element={<CaseStudyLinkedIn study={linkedInCarousels.grandGaming} />} />
                <Route path="/case-studies/kinzy-club/linkedin" element={<CaseStudyLinkedIn study={linkedInCarousels.kinzy} />} />
                
                {/* Company Admin Routes */}
                <Route path="/*" element={
                  <CompanyAdminAuthProvider>
                    <CompanyAdmin />
                  </CompanyAdminAuthProvider>
                } />

                {/* Catch backend redirects */}
                <Route path="/reset-password-employer/*" element={<BackendRedirectHandler />} />
              
              </Routes>
            </ProgressProvider>
            </CompanyAccessProvider>
          </AuthProvider>
        </Router>
      </RecruiterAuthProvider>
    </CompanyProvider>
  );
};

export default App;
